import React from "react";

// Label-over-value stack used by the Bio and Vehicle cards (Fleet, Total Trips,
// Car Model, Number Plate, Car Type): 13px Light grey label above a 16px Medium
// dark-grey value. A legitimate 0 (e.g. Total Trips) still shows; null/empty
// values fall back to an em dash.
const LabeledValue = ({ label, value }) => (
  <div>
    <p className="font-light text-gray-500" style={{ fontSize: 13, marginBottom: 5 }}>
      {label}
    </p>
    <p className="font-medium text-gray-700" style={{ fontSize: 16 }}>
      {value === 0 ? 0 : value || "—"}
    </p>
  </div>
);

export default LabeledValue;
